import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box, Container, Typography, Paper } from '@mui/material';
import { HashRouter } from 'react-router-dom';
import { GameProvider } from './contexts/GameContext';
import PlayerSetup from './components/PlayerSetup';
import GameBoard from './components/GameBoard';
import { useGame } from './contexts/GameContext';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#90caf9',
    },
    secondary: {
      main: '#f48fb1',
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
    },
  },
  shape: {
    borderRadius: 16,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          textTransform: 'none',
          fontSize: '1rem',
          padding: '10px 20px',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 12,
          },
        },
      },
    },
  },
});

function Footer() {
  return (
    <Paper 
      component="footer" 
      elevation={0}
      sx={{ 
        py: 1,
        px: 2,
        backgroundColor: 'rgba(18,18,18,0.8)',
        backdropFilter: 'blur(8px)',
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        borderRadius: '1rem 1rem 0 0',
        borderTop: '1px solid rgba(255,255,255,0.05)',
        maxHeight: '48px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
      }}
    >
      <Typography 
        variant="caption" 
        color="text.secondary" 
        align="center"
        sx={{ 
          fontSize: '0.65rem',
          opacity: 0.7,
          lineHeight: 1.2
        }}
      >
        © {new Date().getFullYear()} Justus • Keine Haftung für getrunkenen Alkohol
      </Typography>
    </Paper>
  );
}

function GameContainer() {
  const { state } = useGame();

  return (
    <Container>
      <Box sx={{ mt: 4, mb: 6 }}>
        {!state.gameStarted ? (
          <PlayerSetup />
        ) : (
          <GameBoard />
        )}
      </Box>
    </Container>
  );
}

function App() {
  return (
    <HashRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GameProvider>
          <GameContainer />
          <Footer />
        </GameProvider>
      </ThemeProvider>
    </HashRouter>
  );
}

export default App;
